import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment';

Vue.use(VueI18n)

/**
 * Load all locale messages.
 *
 * @return {Object}
 */
function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

/**
 * Get language of the browser of the user.
 *
 * @return {string}
 */
export function getLanguage() {
    if (getLanguageSession()) {
        return getLanguageSession();
    }

    let language = window.navigator.userLanguage || window.navigator.language;

    if (window.navigator.languages) {
        language = window.navigator.languages[0];
    }

    setLanguageSession(language.split('-')[0]);
    return language.split('-')[0];
}

/**
 * Get locale from session storage.
 *
 * @return {String|null}
 */
function getLanguageSession() {
    if (window.sessionStorage && window.sessionStorage.getItem('locale')) {
        return window.sessionStorage.getItem('locale');
    }

    return null;
}

/**
 * Set locale in session storage.
 *
 * @param {String} locale
 */
function setLanguageSession(locale) {
    if (!window.sessionStorage) {
        return;
    }

    window.sessionStorage.setItem('locale', locale);
}

/**
 * Set the locale.
 *  - i18n
 *  - moment
 *  - Store in session storage.
 * @param locale
 */
export function setLocale(locale) {
    i18n.locale = locale;
    moment.locale(locale);
    setLanguageSession(locale);
}

/**
 * Remove the locale from the session storage.
 */
export function clearLanguageSession() {
    window.sessionStorage.removeItem('locale');
}

const numberFormats = {
    'de': {
        currency: {
            style: 'currency', currency: 'EUR'
        }
    },
    'en': {
        currency: {
            style: 'currency', currency: 'EUR'
        }
    },
    'es': {
        currency: {
            style: 'currency', currency: 'EUR'
        }
    },
    'fr': {
        currency: {
            style: 'currency', currency: 'EUR'
        }
    },
    'nl': {
        currency: {
            style: 'currency', currency: 'EUR'
        }
    }
};

export const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
    numberFormats
});

setLocale(getLanguage());
